import { FC, useContext } from "react";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";

import DropdownPossibleNextStep from "../dropdownPossibleNextStep";

import { AuthContext } from "src/context/authContext";
import useFetch from "src/hooks/useFetch";

import { MannKindLogo } from "src/assets";
import { AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";
import { HeaderElementType } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import DropdownStatusColorMeaning from "../dropdownStatusColorMeaning";
import useLogout from "src/hooks/useLogout";



const AuthHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation()
  const { userData, isManufacturer, isUserAuthorized } = useContext(AuthContext);
  const { logoutUser } = useLogout()





  const { data: retreatmentRequestCount } =
    useFetch<{ retreatment_count: number; }>(APIEndpoints.GET_RETREATMENT_REQUESTS_COUNT, {}, {}, !isManufacturer);

  const closeMobileMenu = () => {
    const navbarCollapse = document.getElementById('authHeader');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };

  const getHeaderRedirectLink = (headerLink: any, refType: string) => {
    if (headerLink.redirectLink !== "/statistics") {
      return headerLink.redirectLink;
    }

    const routeId = userData?.id;

    if (["Manufacturer"].includes(refType)) return "/statistics";
    if (refType === "dbm") return `/dbm/${routeId}`;
    if (refType === "pn_lead") return `/patientNavigatorLeads/${routeId}`;
    if (refType === "kam_lead") return `/kamleads/${routeId}`;
    if (["patient_navigator", "kam", "rep", "tbm"].includes(refType)) return `/statistics/${routeId}`;

    return `/statistics/${routeId}`;
  };


  return (
    <nav className="navbar navbar-expand-lg p-3 pt-2 pb-2">
      <Link className="navbar-brand p-0" to={isUserAuthorized ?
        (userData?.is_password_changed ?
          (isManufacturer ? userData.ref_type === "Manufacturer" ? `/statistics` : userData.ref_type === "dbm" ? `/dbm/${userData.id}` : userData.ref_type === "kam_lead" ? `/kamleads/${userData.id}` : userData.ref_type === "pn_lead" ? `/patientNavigatorLeads/${userData.id}` : `/statistics/${userData.id}` : (userData.baa_viewed ? `/cases` : "/pages/baa")) :
          '/users/createuser'
        ) :
        `/users/sign_in`
      }
      >
        <img className="img-fluid after-login-logo" src={MannKindLogo} alt="Site logo" />
      </Link>
      <button className="navbar-toggler btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#authHeader">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="authHeader">
        <ul className="navbar-nav me-auto first-nav">
          {userData?.is_password_changed ? (
            <>
              {isManufacturer === true ?
                AuthenticatedManufactureHeader.map((headerLink, index) => (
                  <li
                    className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                    key={index}
                  >
                    {headerLink.actionType === HeaderElementType.ROUTE ? (
                      <NavLink
                        className={({ isActive }) => {
                          return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                        }}
                        aria-current="page"
                        to={getHeaderRedirectLink(headerLink, userData?.ref_type?.toLowerCase())}
                        end
                        // onClick={closeMobileMenu}
                        onClick={(e) => {
                          if (headerLink.title === "National") {
                            e.preventDefault(); // stops redirect
                            return;
                          }

                          closeMobileMenu();
                        }}
                      >
                        {headerLink.title}
                      </NavLink>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.BUTTON ? (
                      <button
                        className="btn btn-primary rounded-pill"
                        onClick={() => {
                          closeMobileMenu();
                          navigate(headerLink.redirectLink);
                        }}
                      >
                        {headerLink.title}
                      </button>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.LINK ? (
                      <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                        {headerLink.title}
                      </a>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                      <>
                        <a
                          className="nav-link dropdown-toggle"
                          href="." data-bs-toggle="dropdown" aria-expanded="false"
                        >
                          {headerLink.title}
                        </a>
                        <ul className="resources-dropdown dropdown-menu dropdown-center">
                          {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                            <li key={index}>
                              {header.redirectLink === "" ? <span className="dropdown-item">{header.title}</span> :
                                <a
                                  className="dropdown-item" href={header.redirectLink} target="_blank"
                                  rel="noreferrer"
                                >
                                  {header.title}
                                </a>}
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : null}
                  </li>
                ))
                :
                <>
                  {userData.baa_viewed && AuthenticatedHCPHeader.map((headerLink, index) => (
                    <li
                      className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                      key={index}
                    >
                      {headerLink.actionType === HeaderElementType.ROUTE ? (
                        <NavLink
                          className={({ isActive }) => {
                            return ["nav-link text-nowrap", isActive ? "custom-active-link" : ""].join(" ")
                          }}
                          reloadDocument={
                            headerLink.redirectLink === "/cases/new" &&
                            (location.pathname.includes("clone") || location.pathname.includes("new"))
                          }
                          aria-current="page"
                          to={headerLink.redirectLink}
                          end
                          onClick={closeMobileMenu}
                        >
                          <span>{headerLink.title}</span>{' '}
                          {headerLink.redirectLink === "/retreatments" ?
                            retreatmentRequestCount ?
                              (
                                <span className="bg-primary text-white rounded-1 p-1" style={{ fontSize: 11 }}>
                                  {retreatmentRequestCount.retreatment_count}
                                </span>
                              ) : (
                                <span className="placeholder-glow">
                                  <span className="placeholder bg-primary" style={{ minWidth: 15 }}></span>
                                </span>
                              )
                            : null
                          }
                          {headerLink.redirectLink === "/cases/new" && userData && userData.draft_count > 0 ?
                            <span
                              className="badge rounded-circle text-bg-danger"
                              style={{
                                position: "relative",
                                fontSize: 10,
                                top: -2,
                              }}
                            >
                              {userData?.draft_count}
                            </span>
                            : null
                          }
                        </NavLink>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.BUTTON ? (
                        <button
                          style={{ background: 'background-color-5' }}
                          className="btn btn-primary rounded-pill"
                          onClick={() => {
                            closeMobileMenu();
                            navigate(headerLink.redirectLink);
                          }}
                        >
                          {headerLink.title}
                        </button>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.LINK ? (
                        <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                          {headerLink.title}
                        </a>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                        <>
                          <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {headerLink.title}
                          </a>
                          <ul className="resources-dropdown dropdown-menu dropdown-center" style={{ top: '53px' }}>
                            {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                              <li key={index}>
                                {header.redirectLink === "" ? <span className="dropdown-item">{header.title}</span> :
                                  <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer">
                                    {header.title}
                                  </a>}
                              </li>
                            ))}
                          </ul>
                        </>
                      ) : null}
                    </li>
                  ))}
                </>
              }
            </>
          ) : null}
        </ul>

        <div className="text-start text-lg-end">
          <ul className="navbar-nav justify-content-end">
            {userData?.is_password_changed ? (
              isManufacturer ?
                <>
                  <DropdownStatusColorMeaning />
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                      aria-expanded="false" role="button"
                    >
                      {userData?.name}
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end" style={{ width: '180px' }}>
                      <li>
                        <Link className="dropdown-item" to='/users/updateuser' onClick={closeMobileMenu}>
                          Account Settings
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <button className="dropdown-item"
                          onClick={() => logoutUser()}
                        >Logout</button>
                      </li>
                    </ul>
                  </li>
                </>
                :
                <>
                  {userData?.baa_viewed ? (
                    <>
                      <DropdownStatusColorMeaning />
                      <DropdownPossibleNextStep />
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle" href="."
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          role="button"
                        >
                          {userData?.name}
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end" style={{ width: '180px' }}>
                          <li><Link className="dropdown-item" to="/users/updateuser" onClick={closeMobileMenu}>
                            Account Settings</Link>
                          </li>
                          <li><Link className="dropdown-item" to="/users/new" onClick={closeMobileMenu}>Add User</Link>
                          </li>
                          <li><Link className="dropdown-item" to="/doctors/new" onClick={closeMobileMenu}>
                            Add Prescriber
                          </Link></li>
                          {/* {USER_TYPES.HCP.includes(userData.ref_type) && userData.ref_type !== "GlobalDoctor" && (
                                  <li>
                                      <Link className="dropdown-item" to="/pages/signaturemanagement" onClick={closeMobileMenu}>
                                          Add Signature
                                      </Link>
                                  </li>
                              )} */}


                          <li><Link className="dropdown-item" to="/pages/baa" onClick={closeMobileMenu}>BAA</Link></li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <button className="dropdown-item"
                              onClick={() => {
                                closeMobileMenu();
                                logoutUser();
                              }}>
                              Logout
                            </button>
                          </li>
                        </ul>
                      </li>
                    </>
                  ) : (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                        aria-expanded="false" role="button"
                      >
                        {userData?.name}
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end">
                        <li><button className="dropdown-item"
                          onClick={() => {
                            closeMobileMenu();
                            logoutUser();
                          }}>
                          Logout</button></li>
                      </ul>
                    </li>
                  )}
                </>
            ) : (
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {userData?.name}
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li><a className="dropdown-item" href="."
                    onClick={() => {
                      closeMobileMenu();
                      logoutUser();
                    }}>Logout</a></li>
                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AuthHeader;
